let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jsenQ")).then(() => parcelRequire('7jBq3'));